import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const invoiceDiscountSchema = z.object({
  description: z.string().optional(),
  title: z.string().optional(),
  amount: z.number(),
});

const invoiceItemSchema = z.object({
  discount: invoiceDiscountSchema.optional(),
});

const invoiceShippingItemSchema = z.object({
  title: z.string(),
  amount: z.number(),
});

const invoiceSchema = z.object({
  items: z.array(invoiceItemSchema),
  discount: invoiceDiscountSchema.optional(),
  shipping: invoiceShippingItemSchema.optional(),
});

export const getExchangeInvoice = {
  name: "getExchangeInvoice" as const,
  input: z.object({ returnId: zExt.objectId() }),
  output: invoiceSchema,
};
